<template>
  <div>
    <vs-row class="catBgClr mx-4">
      <vs-row>
        <h3 class="p-5 pb-4">Add Top Issuers</h3>
      </vs-row>

      <vs-row>
        <div
          class="flex flex-wrap-reverse items-center ml-5 cursor mt-5 mb-5 pt-0"
          @click="addNewIssuer"
        >
          <PlusSquareIcon color="white" />
          <h6 class="ml-2 mt-1 cursor">Add Issuer</h6>
        </div>
      </vs-row>

      <vs-row :key="index" v-for="(issu, index) in topIssuer" class="ml-5 mb-5">
        <vs-col vs-lg="5" vs-sm="6" class="pr-6">
          <vs-row>
            <vs-col vs-lg="11">
              <div class="my-2 ml-1">
                <vs-row>
                  <vs-col
                    vs-lg="5"
                    vs-sm="5"
                    class="inputContainer max-height-5-24"
                    vs-type="flex"
                    vs-justify="flex-start"
                  >
                    Issuer {{ index + 1 }}
                  </vs-col>
                </vs-row>
              </div>
              <div class="dropdown mt-0 w-full" id="dropdown">
                <vs-input
                  class="w-full p-3 pl-0 pt-0"
                  @click="handleFilter(index), scrollToBottomInput()"
                  v-on-clickaway="closeColorList1(index)"
                  v-model="topIssuer[index].name"
                  :disabled="topIssuer[index]._id != ''"
                  readonly
                />
                <div
                  class="dropdown-content"
                  v-show="
                    topIssuer[index]._id == '' &&
                    toggleColorList &&
                    topIssuer[index].toggleColorList == true
                  "
                >
                  <div
                    class="colorItemContainer"
                    :key="index1"
                    @click="issuerSelect(index, issuer), closeColorList(index)"
                    v-for="(issuer, index1) in issuersList"
                  >
                    <div
                      class="colorIconStyle"
                      :style="{ 'background-color': issuer.color }"
                    ></div>
                    <span class="colorTextStyle">{{ issuer.name }}</span>
                  </div>
                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-lg="2" vs-sm="3" vs-type="flex" vs-justify="flex-start">
          <div class="items-center mt-10">
            <p class="whiteText" style="direction: rtl">
              {{
                topIssuer[index].removedCards
                  ? topIssuer[index].removedCards
                  : 0
              }}/{{
                topIssuer[index].totalCards ? topIssuer[index].totalCards : 0
              }}
            </p>
            <p>Excluded Cards</p>
          </div>
        </vs-col>
        <vs-col vs-lg="2" vs-sm="3" vs-type="flex" vs-justify="flex-start">
          <div
            v-if="
              topIssuer[index].isDeleteable ||
              topIssuer[index].isDeleteable == undefined
            "
            class="flex flex-wrap-reverse items-center cursor mt-1 pl-4"
            @click="removeIssuer(index)"
          >
            <MinusSquareIcon color="white" class="mt-5" />
            <div class="addCardFont font-semibold ml-3 cursor mt-6 whiteText">
              Remove
            </div>
          </div>
        </vs-col>

        <vs-col vs-lg="3" vs-sm="3" class="mt-10 pt-0" vs-justify="flex-start">
          <vs-row class="">
            <vs-button
              v-if="topIssuer[index]._id != ''"
              class="manageButton"
              @click="toManage(issu)"
              >Exclude Credit Cards</vs-button
            >
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row v-if="errors.issuers.success">
        <p class="p-5 py-3 dangerColor">{{ errors.issuers.msg }}</p>
      </vs-row>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="updateStatus.status"
      >
        <h5>{{ updateStatus.msg }}</h5>
      </vs-popup>
    </vs-row>

    <vs-row class="mt-2 pr-10 pl-1" vs-justify="flex-end">
      <vs-button @click="updateissuers">Save</vs-button>
    </vs-row>
    <vs-popup
      class="holamundo"
      title="Status"
      :active.sync="NoIssuer.status"
      @close="closefunc()"
    >
      <h5>{{ NoIssuer.msg }}</h5>
    </vs-popup>
  </div>
</template>

<script>
import { PlusSquareIcon, MinusSquareIcon, MenuIcon } from "vue-feather-icons";
import draggable from "vuedraggable";
import { genericErrorMessage, toast } from "@/keys/toast-messages";
import { mixin as clickaway } from "vue-clickaway";
import EventBus from "@/event-bus.js";

export default {
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    MenuIcon,
    draggable,
  },

  mixins: [clickaway],
  data() {
    return {
      topIssuer: [],
      remove_issuers: [],
      issuersList: [],
      toggleColorList: false,
      tempIssuerHolder: "",
      errors: {
        issuers: {
          msg: "",
          success: false,
        },
        duplicateIndices: [],
      },

      updateStatus: {
        msg: "",
        status: false,
      },
      NoIssuer: {
        msg: "",
        status: false,
      },
      genericErrorMessage,
      toast,
    };
  },
  methods: {
    async notempty() {
      for (var i = 0; i < this.topIssuer.length; i++) {
        if (this.topIssuer[i].name == "" || !this.topIssuer[i].name.trim()) {
          this.errors.issuers = {
            msg: "Please fill the issuer field",
            success: true,
          };
          return false;
        } else {
          this.errors.issuers = {
            msg: "",
            success: false,
          };
        }
      }
      return true;
    },

    closeColorList1(index) {
      if (this.toggleColorList == true) {
        if (!(index instanceof Number)) {
          this.closeColorList22(index);
        }
      }
      //console.log("inp on clickaway", index);
      let ab = this.closeColorList1;
      return ab;
    },
    scrollToBottom() {
      window.scrollTo(0, document.body.scrollHeight);
    },

    scrollToBottomInput() {
      window.scrollTo(0, document.body.scrollHeight);
    },

    async removeIssuer(index) {
      if (this.topIssuer[index]._id) {
        await this.remove_issuers.push(this.topIssuer[index]._id);
      }
      this.topIssuer.splice(index, 1);
      await this.notempty();
    },
    async addNewIssuer() {
      if (await this.notempty()) {
        await this.topIssuer.push({ _id: "", name: "", issuer: "" });
        this.topIssuer = await this.topIssuer.map((value, index) => {
          return {
            name: value.name,
            issuer: value.issuer,
            _id: value._id,
            order: index + 1,
            toggleColorList: false,
            totalCards: value.totalCards,
            removedCards: value.removedCards ? value.removedCards : 0,
            removed_credit_card: value.removed_credit_card
              ? value.removed_credit_card
              : [],
          };
        });
        this.scrollToBottom();
      }
    },
    getCheatSheetIssuers() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve, reject) => {
        this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.CheatSheet)
          .then(async (res) => {
            if (res.data.success) {
              resolve((this.topIssuer = res.data.data));

              //await this.populateCardlist();
              await this.getcardcount();
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
            this.$vs.loading.close();
          });
      });
    },

    async getcardcount() {
      this.topIssuer = await this.topIssuer.map((value, index) => {
        return {
          name: value.name,
          issuer: value.issuer,
          _id: value._id,
          order: index + 1,
          toggleColorList: false,
          totalCards: value.allcardslength,
          removedCards: value.removed_credit_card.length,
          removed_credit_card: value.removed_credit_card,
        };
      });
    },

    async hasUniqueNames() {
      var tmpArr = [];
      for (var i = 0; i < this.topIssuer.length; i++) {
        if (tmpArr.indexOf(this.topIssuer[i].name) < 0) {
          tmpArr.push(this.topIssuer[i].name);
        } else {
          // this.error.duplicateIndices.push(i);
          return false;
        }
      }
      return true;
    },
    async updateissuers() {
      this.hasUniqueNames(this.topIssuer);
      if (await this.notempty()) {
        if (await this.hasUniqueNames(this.topIssuer)) {
          this.errors.issuers = {
            msg: "",
            success: false,
          };
          this.topIssuer = await this.topIssuer.map((value, index) => {
            return {
              issuer: value.issuer,
              _id: value._id,
              order: index + 1,
              removed_credit_card: value.removed_credit_card,
            };
          });
          let isAdded =
            this.topIssuer.findIndex((element) => element._id == "") != -1
              ? true
              : false;
          this.timer = setTimeout(() => {
            this.$vs.loading.close();
            this.$vs.loading({
              background: "rgba(1,2,3,.2)",
            });
            return new Promise((resolve, reject) => {
              const fixedIssuers = this.topIssuer.map( (issuer) => 
                { return { 
                  ...issuer , _id: issuer._id !== "" ? issuer._id: null 
                  }
                })
              this.$axios
                .patch(
                  this.$ApiKeys.BASE_URL + this.$EndPoints.CheatSheet,
                  {
                    issuers: fixedIssuers,
                    remove_issuers: this.remove_issuers,
                    isAdded: isAdded,
                  }
                )
                .then(async (res) => {
                  const errors = res.data.response && 
                  res.data.response.errors &&
                  res.data.response.errors[0] &&
                  res.data.response.errors[0].response &&
                  res.data.response.errors[0].response.errors ? res.data.response.errors[0].response.errors : null;
                  this.$vs.loading.close();
                  if (res.data.success) {
                    this.updateStatus = {
                      msg: res.data.message,
                      status: true,
                    };
                    resolve(this.getCheatSheetIssuers());
                  } else if (errors && errors[0][Object.keys(errors[0])[0]]) {
                    this.errors.issuers = {
                      msg: errors[0][Object.keys(errors[0])[0]],
                      success: true,
                    };
                  } else {
                    this.toast(this.genericErrorMessage());
                  }
                })
                .catch((e) => {
                  if (e.response.status !== 401) {
                    this.toast(this.genericErrorMessage());
                  }
                  this.$vs.loading.close();
                });
            });
          }, 500);
        } else {
          this.errors.issuers = {
            msg: "Issuer name must be unique.",
            success: true,
          };
        }
      }
    },
    async toManage(inp) {
      await this.$router.push({
        path: "/cheatsheet/excludecards/" + inp._id,
      });
    },
    async handleFilter(index) {
      if (this.toggleColorList != true) {
        this.topIssuer[index].toggleColorList = true;
        this.toggleColorList = true;
        (this.tempIssuerHolder = this.topIssuer[index].name),
          this.topIssuer[index]._id;
      }
    },
    async closeColorList22(index) {
      if (
        index &&
        index.target &&
        index.target.disabled != false &&
        this.toggleColorList == true
      ) {
        this.toggleColorList = false;
      }
    },
    async closeColorList(index) {
      if (this.topIssuer[index].toggleColorList == true) {
        this.topIssuer[index].toggleColorList = false;
        this.toggleColorList = false;
        // if (this.cardDetails.selectedIssuer.name) {
        //   this.errors.issuerName = {
        //     msg: "",
        //     success: false,
        //   };
        // }
      }
    },
    async issuerSelect(inp1, inp2) {
      this.topIssuer[inp1].issuer = inp2._id;
      this.topIssuer[inp1].name = inp2.name;
    },
    getIssuers() {
      return new Promise(async (resolve) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.IssuerColors, { 
            params: { color: true } 
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve(
                (this.issuersList = res.data.data.issuers),
                (this.filtererdList = res.data.data.filteredIssuers)
              );
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
  },
  created() {
    this.getIssuers();
    this.getCheatSheetIssuers();
    EventBus.$emit("resetToggleGroup", true);
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>

<style>
@import "./style.css";
</style>
